export default {
  labels: {
    sold_out: 'Epuizat!',
    most_popular: '#{{rank}} Cel mai apreciat',
    last_ordered: 'Comandat ultima dată',
  },
};
